import { render } from "./CreditiUsciti.vue?vue&type=template&id=37473e15"
import script from "./CreditiUsciti.vue?vue&type=script&lang=js"
export * from "./CreditiUsciti.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__